import request from '@/utils/request'

export function getCertificates(params) {
  return request({
    url: '/cvs/certs',
    method: 'get',
    params
  })
}

export function getList(params) {
  return request({
    url: '/cvs',
    method: 'get',
    params
  })
}

export function getResume(id) {
  return request({
    url: `/cvs/${id}`,
    method: 'get'
  })
}

export function createResume(data) {
  return request({
    url: '/cvs',
    method: 'post',
    // config: { headers: { 'Content-Type': 'multipart/form-data' }},
    data
  })
}

export function updateResume(id, data) {
  return request({
    url: `/cvs/${id}`,
    method: 'put',
    // config: { headers: { 'Content-Type': 'multipart/form-data' }},
    data
  })
}

export function deleteResume(id) {
  return request({
    url: `/cvs/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/cvs.js